/** One choice in a progress filter. */
export interface FilterOption {
  id: number | string;
  name: string;
}

/** Choices for the progress filters, returned with the status summary. */
export interface ProgressFilterOptions {
  assessment_types: FilterOption[];
  clients: FilterOption[];
  periods: FilterOption[];
}

/**
 * Filters shared by the status pie and the progress table. Replace the whole
 * object on change so both components see it.
 *   assessmentType: assessment master id (CIA Lite and CIA Comprehensive share a type)
 *   organizationIds: empty for every client
 *   period: '<start>_<end>' key from the period options
 */
export interface ProgressFilters {
  assessmentType: number | null;
  organizationIds: number[];
  period: string | null;
}

export const NO_FILTERS: ProgressFilters = { assessmentType: null, organizationIds: [], period: null };

export const NO_OPTIONS: ProgressFilterOptions = { assessment_types: [], clients: [], periods: [] };
